import { actions } from  '../constants';
import store from '../store';
import { remoteCall } from '../lib';

function loadingPatient(patientId) {
  return {
    type: actions.PATIENT_REQUESTED,
    payload: {
      patientId
    }
  };
}

function loadingPatientFailed(error, patientId) {
  return {
    type: actions.PATIENT_REQUEST_FAILED,
    payload: {
      patientId,
      error
    }
  };
}

function patientLoaded(patient) {
  return {
    type: actions.PATIENT_RECEIVED,
    payload: {
      patient
    }
  };
}

export function loadPatient(patientId){
  return (dispatch) => {
    const cachedPatient = store.getState().patients.get('patientsById').get(patientId);
    if ( cachedPatient && cachedPatient.get('loaded') ) {
      return dispatch(patientLoaded( cachedPatient ));
    }
    
    dispatch(loadingPatient(patientId));
    remoteCall(`patients/${patientId}`, 'patient').then((patient) =>{      
      dispatch(patientLoaded(patient));
    }).catch((err) => {
      dispatch(loadingPatientFailed(err, patientId));
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/patient.js